<div class="feedback-container-bottom">
    <span class="feedback-text hmf-pb-xs">How are we doing?</span>
	<button
		hmf-button
		variant="secondary"
		class="feedback-button-link"
		(click)="loadSurvey()"
		data-em="Feedback_Survey"
		tabindex="0"
		text="GIVE FEEDBACK"
	>
	</button>
</div>
